export default __webpack_public_path__ + "static/NewsImage2-61400741e86054eb1fa09905a1b50c93.jpg";